class AgeVerifier extends ModalElement {
  constructor() {
    super();
    this.init();
  }

  get testMode() {
    return this.getAttribute("data-test-mode") === "true";
  }

  get delay() {
    return 1; // Delay in seconds
  }

  get storageKey() {
    return "ageVerifierShown";
  }

  init() {
    // Check if test mode is enabled or the session storage key is missing
    if (this.testMode || !sessionStorage.getItem(this.storageKey)) {
      this.load(this.delay);
    }
  }

  load(delay) {
    // Show the modal after a delay
    Shopify && Shopify.designMode || setTimeout(() => this.show(), delay * 1000);
  }

  afterShow() {
    super.afterShow();
    this.classList.add("show-image");
  }

  afterHide() {
    super.afterHide();
    this.classList.remove("show-image");

    // Set sessionStorage only if test mode is not enabled
    if (!this.testMode) {
      sessionStorage.setItem(this.storageKey, "true");
    }
  }
}

customElements.define("age-verifier", AgeVerifier);
